import { func } from 'prop-types';
import React from 'react';
import { Button, ModalBody } from 'reactstrap';

import createModalToggle from '../../../generic/create-modal-toggle';
import { contactListShape } from '../../../prop-types';
import api from '../../../REST/api';
import withApiRequest from '../../../REST/with-api-request';
import { COLORS } from '../../../utils/constants';
import { addToListColumns } from '../../contact-columns';
import ListContacts from '../../ListContacts';

const ModalContent = ({ list, onRequest, onSuccess }) => {
  return (
    <ModalBody>
      <ListContacts
        title="Select contacts to add"
        showAddContactButton={false}
        columns={addToListColumns}
        selectListAction={({ disabled, selectedContactIds }) => (
          <Button
            disabled={disabled}
            onClick={() => {
              return onRequest({
                id: list.id,
                data: {
                  contactIds: list.contactIds.concat(selectedContactIds),
                },
              }).then(onSuccess);
            }}
          >
            Add selected contacts
          </Button>
        )}
      />
    </ModalBody>
  );
};

ModalContent.propTypes = {
  list: contactListShape.isRequired,
  onRequest: func.isRequired,
  onSuccess: func.isRequired,
};

const QuickAddContactsToListModal = createModalToggle(
  'Add new contacts to list',
  withApiRequest({
    query: api.patchContactList,
    error: 'flash',
    successMessage: 'Selected Contact(s) added to the list',
  })(ModalContent),
  { color: COLORS.PRIMARY },
  { size: 'xl' },
);

export default QuickAddContactsToListModal;
